import Vue from 'vue'
import VueRouter from 'vue-router'

import YscIndex from '../pages/YscIndex.vue'
import SaleCar from '../pages/SaleCar.vue'
import SubSaleCar from '../pages/subpages/SubSaleCar.vue'
import Assessment from '../pages/Assessment.vue'
import SellingCar from '../pages/SellingCar.vue'
import SubstitutionCar from '../pages/SubstitutionCar.vue'
import AboutDesign from '../pages/AboutDesign.vue'
import About from '../pages/aboutpages/AboutD.vue'
import Activity from '../pages/aboutpages/AboutActivity.vue'
import Service from '../pages/aboutpages/AboutService.vue'
import Problem from '../pages/aboutpages/AboutProblem.vue'
import AboutActivityDetails from '../pages/aboutpages/details/AboutActivityDetails.vue'

Vue.use(VueRouter)

export default new VueRouter({
    // mode: 'history', 
    base: '/',
    routes: [{
            path: '/',
            redirect: '/yscindex'
        },
        {
            path: '/yscindex',
            component: YscIndex
        },
        {
            path: '/salecar',
            name: 'salecar',
            component: SaleCar
        },
        {
            path: '/assessment',
            component: Assessment
        },
        {
            path: '/sellingcar',
            component: SellingCar
        },
        {
            path: '/substitutioncar',
            component: SubstitutionCar
        },
        {
            path: '/aboutdesign',
            component: AboutDesign,
            children: [{
                    path: '',
                    redirect: '/aboutdesign/about'
                },
                {
                    path: 'about',
                    component: About
                },
                {
                    path: 'activity',
                    component: Activity
                },
                {
                    path: 'service',
                    component: Service
                },
                {
                    path: 'problem',
                    component: Problem
                },
                {
                    path: '/aboutdesign/details/:ActivityId',
                    component: AboutActivityDetails
                }
            ]
        },
        {
            path: '/salecar/subsalecar/:goodId',
            name: 'SubSaleCar',
            component: SubSaleCar
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js